module.exports = __webpack_public_path__ + "img/nature-50.f093002d.jpg";